import { useAppTheme } from "@hooks/useAppTheme";
import { Box, useDevice } from "@memorang/ui";
import ContentLoader from "react-native-easy-content-loader";
import { Card } from "react-native-paper";

const flatContainer = { paddingHorizontal: 0, width: "100%" as const };
const flatParagraph = { marginVertical: 0, borderRadius: 4 };

const RecommendationCardSkeleton = () => {
	const theme = useAppTheme();

	return (
		<Card
			mode="outlined"
			style={{
				flex: 1,
				overflow: "hidden",
				borderRadius: theme.roundness,
				backgroundColor: theme.colors.surface,
				borderColor: theme.colors.outlineVariant,
			}}
		>
			<Card.Content style={{ padding: 16 }}>
				<Box gap={12}>
					{/* Thumbnail + title */}
					<Box gap={12} flexDirection="row" alignItems="flex-start">
						{/*@ts-ignore*/}
						<ContentLoader
							avatar
							aSize={44}
							aShape="square"
							title={false}
							pRows={0}
							avatarStyles={{ marginRight: 0 }}
							containerStyles={{ paddingHorizontal: 0, width: 44 }}
						/>
						<Box flex={1} minWidth={0} gap={6}>
							{/*@ts-ignore*/}
							<ContentLoader
								title={false}
								pRows={1}
								pHeight={12}
								pWidth="92%"
								paragraphStyles={flatParagraph}
								containerStyles={flatContainer}
							/>
							{/*@ts-ignore*/}
							<ContentLoader
								title={false}
								pRows={1}
								pHeight={12}
								pWidth="55%"
								paragraphStyles={flatParagraph}
								containerStyles={flatContainer}
							/>
						</Box>
					</Box>
					{/* Progress bar (real bar has marginHorizontal:4) */}
					{/*@ts-ignore*/}
					<ContentLoader
						title={false}
						pRows={1}
						pHeight={8}
						pWidth="100%"
						paragraphStyles={{ ...flatParagraph, borderRadius: 0 }}
						containerStyles={{ paddingHorizontal: 0, width: "100%" }}
					/>
				</Box>
			</Card.Content>
			<Card.Actions
				style={{
					paddingHorizontal: 16,
					paddingTop: 0,
					paddingBottom: 16,
					justifyContent: "space-between",
					alignItems: "flex-end",
				}}
			>
				{/* Duration chip */}
				{/*@ts-ignore*/}
				<ContentLoader
					title={false}
					pRows={1}
					pHeight={20}
					pWidth={64}
					paragraphStyles={{ marginVertical: 0, borderRadius: 6 }}
					containerStyles={{ paddingHorizontal: 0, width: 64 }}
				/>
				{/* Action button */}
				{/*@ts-ignore*/}
				<ContentLoader
					title={false}
					pRows={1}
					pHeight={34}
					pWidth={90}
					paragraphStyles={{ marginVertical: 0, borderRadius: 22 }}
					containerStyles={{ paddingHorizontal: 0, width: 90 }}
				/>
			</Card.Actions>
		</Card>
	);
};

// Mirrors ModuleRecommendationContent variant="inline": thumbnail 56 + title/subtitle
// + trailing action, in a centered row. Used in the exam header while data loads.
export const InlineRecommendationSkeleton = () => (
	<Box flexDirection="row" alignItems="center" gap={16} flex={1}>
		{/*@ts-ignore*/}
		<ContentLoader
			avatar
			aSize={56}
			aShape="square"
			title={false}
			pRows={0}
			avatarStyles={{ marginRight: 0 }}
			containerStyles={{ paddingHorizontal: 0, width: 56 }}
		/>
		<Box flex={1} minWidth={0} gap={6}>
			{/*@ts-ignore*/}
			<ContentLoader
				title={false}
				pRows={1}
				pHeight={14}
				pWidth="70%"
				paragraphStyles={flatParagraph}
				containerStyles={flatContainer}
			/>
			{/*@ts-ignore*/}
			<ContentLoader
				title={false}
				pRows={1}
				pHeight={12}
				pWidth="40%"
				paragraphStyles={flatParagraph}
				containerStyles={flatContainer}
			/>
		</Box>
		{/* Trailing action */}
		{/*@ts-ignore*/}
		<ContentLoader
			title={false}
			pRows={1}
			pHeight={20}
			pWidth={96}
			paragraphStyles={{ marginVertical: 0, borderRadius: 6 }}
			containerStyles={{ paddingHorizontal: 0, width: 96 }}
		/>
	</Box>
);

export const RecommendationsSkeleton = () => {
	const { isMobile } = useDevice();
	return (
		<Box
			flexDirection="row"
			style={{
				gap: 8,
				paddingHorizontal: isMobile ? 16 : 0,
				paddingLeft: isMobile ? 16 : 1,
				paddingBottom: 1,
			}}
		>
			<RecommendationCardSkeleton />
			<RecommendationCardSkeleton />
		</Box>
	);
};

export default RecommendationCardSkeleton;
